export const RESERVED_WORDS = [
  // Company and Brand Names
  'admin',
  'administrator',
  'stripe',
  'plink',
  'plinktree',
  'plinkpos',
  'toop',
  'vip',
  'toopvip',
  'toop_vip',
  'Vioo',
  'ViooVIP',
  'company',
  'official',
  'support',
  'help',

  // Common System Routes
  'login',
  'logout',
  'register',
  'signup',
  'signin',
  'signout',
  'auth',
  'account',
  'settings',
  'profile',
  'dashboard',
  'home',
  'about',
  'contact',
  'privacy',
  'terms',
  'tos',
  'legal',

  // Social Media Related
  'instagram',
  'facebook',
  'twitter',
  'tiktok',
  'youtube',
  'linkedin',
  'pinterest',
  'snapchat',
  'whatsapp',

  // Generic Terms
  'user',
  'username',
  'system',
  'root',
  'administrator',
  'mod',
  'moderator',
  'admin1',
  'test',
  'testing',
  'demo',
  'example',
  'sample',
  'null',
  'undefined',
  'true',
  'false',
  'default',

  // Security Related
  'security',
  'secure',
  'password',
  'login',
  'authorize',
  'authentication',
  'verified',
  'official',

  // Business Terms
  'sales',
  'marketing',
  'billing',
  'payment',
  'subscribe',
  'premium',
  'business',
  'enterprise',
  'corporate',

  // Common Actions
  'edit',
  'delete',
  'remove',
  'update',
  'create',
  'new',
  'manage',
  'control',
  'api',
  'dev',
  'developer',
  'app',
  'mobile',
  'web',

  // Status Related
  'status',
  'maintenance',
  'error',
  '404',
  '500',
  'banned',
  'suspended',
  'deactivated',

  // Protected Routes
  'public',
  'private',
  'internal',
  'external',
  'system',
  'config',
  'setting',
  'settings',
  'preference',
  'preferences',
];

// Function to check if a username is reserved
export const isReservedUsername = (username: string): boolean => {
  const lowercaseUsername = username.toLowerCase();
  return RESERVED_WORDS.includes(lowercaseUsername) ||
    // Check for common variations
    RESERVED_WORDS.some(word => 
      lowercaseUsername.includes(word) && 
      (lowercaseUsername.startsWith(word) || lowercaseUsername.endsWith(word))
    ) ||
    // Check for common patterns with numbers
    /^(admin|mod|test|user)\d+$/.test(lowercaseUsername) ||
    // Check for common separators
    RESERVED_WORDS.some(word => 
      lowercaseUsername.includes(`-${word}`) || 
      lowercaseUsername.includes(`${word}-`) ||
      lowercaseUsername.includes(`_${word}`) || 
      lowercaseUsername.includes(`${word}_`)
    );
};

// Function to validate username format
export const isValidUsername = (username: string): boolean => {
  // Username must:
  // - Be between 3 and 30 characters
  // - Start with a letter
  // - Contain only letters, numbers, underscores, or hyphens
  // - Not be a reserved word
  const usernameRegex = /^[a-zA-Z][a-zA-Z0-9_-]{2,29}$/;
  return usernameRegex.test(username) && !isReservedUsername(username);
}; 